import { render, staticRenderFns } from "./CourseSchedule.vue?vue&type=template&id=d399efa0&scoped=true&"
import script from "./CourseSchedule.vue?vue&type=script&lang=js&"
export * from "./CourseSchedule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d399efa0",
  null
  
)

export default component.exports